import api from '../../api/http-common';
import apiClient from '../../api/http-common';

const blockUserById = async (id: string): Promise<null> => {
  const { data } = await apiClient.post(`/users/${id}/block`);

  return data;
};

const unblockUserById = async (id: string): Promise<null> => {
  const { data } = await apiClient.post(`/users/${id}/unblock`);

  return data;
};

const sendPasswordResetLinkToUserById = async (id: string): Promise<null> => {
  const { data } = await apiClient.post(`/users/${id}/send-password-reset-link`);

  return data;
};

const resendActivation = (id: string) =>
  apiClient.post(`/users/${id}/resend-activation-mail`)

const getUserOptionsData = (): any =>
  apiClient.post('/users/get-options-data')

const getEditUser = (id: string) =>
  apiClient.post(`/users/${id}/edit`)

const storeUser = async (data) => {
  const response = await apiClient.post('/users/store', data);

  return response.data;
};

const editUser = async (data) => {
  const response = await apiClient.post(`users/${data.id}/update`, data);

  return response.data;
};

const updateUser = (id: string, data) =>
  apiClient.post(`/users/${id}/update`, data)

const showUser = (id: string) =>
  apiClient.post(`/users/${id}/show`)

const getUserFile = (id: string) =>
  apiClient.post(`/users/${id}/get-file`)

const deleteUser = (id: string) =>
  apiClient.post(`/users/${id}/delete`)

const getUserList = (data?) =>
  apiClient.post('/users/index', data)

const UsersService = {
  blockUserById,
  unblockUserById,
  sendPasswordResetLinkToUserById,
  getUserOptionsData,
  getEditUser,
  storeUser,
  editUser,
  getUserFile,
  getUserList,
  updateUser,
  deleteUser,
  showUser,
  resendActivation
}

export interface IUsersData {
  data: {
    filtered: number;
    rows: any[];
    total: number;
  }
}

export default UsersService
